import React from "react";
import styles from "./index.module.scss";
import img from "./update.svg";
export default class Update extends React.Component {
    static defaultProps = {
        className: "",
        onClick: () => { },
    };
    render() {
        return (React.createElement("img", { onClick: this.props.onClick, src: img, alt: "Update Icon", className: `${styles.update} ${this.props.className}` }));
    }
}
